import { render, staticRenderFns } from "./data-tag-pool.vue?vue&type=template&id=1f37b062&scoped=true&"
import script from "./data-tag-pool.vue?vue&type=script&lang=js&"
export * from "./data-tag-pool.vue?vue&type=script&lang=js&"
import style0 from "./data-tag-pool.vue?vue&type=style&index=0&id=1f37b062&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f37b062",
  null
  
)

export default component.exports